// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"gesture-up"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M12.25 9V4.5C12.25 3.39543 11.3546 2.5 10.25 2.5C9.14543 2.5 8.25 3.39543 8.25 4.5V14.5L4.41889 13.6486C4.01575 13.5591 3.599 13.7265 3.36991 14.0701L2.75 15L7.14955 20.7194C7.52815 21.2116 8.11386 21.5 8.7348 21.5H16.8085C17.6693 21.5 18.4336 20.9491 18.7058 20.1325L20.7362 14.0414C21.0356 13.1433 20.6643 12.1583 19.8466 11.6813L15.717 9.27244C15.4112 9.09402 15.0634 9 14.7093 9H12.25Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12.25 9V4.5C12.25 3.39543 11.3546 2.5 10.25 2.5C9.14543 2.5 8.25 3.39543 8.25 4.5V14.5L4.41889 13.6486C4.01575 13.5591 3.599 13.7265 3.36991 14.0701L2.75 15L7.14955 20.7194C7.52815 21.2116 8.11386 21.5 8.7348 21.5H16.8085C17.6693 21.5 18.4336 20.9491 18.7058 20.1325L20.7362 14.0414C21.0356 13.1433 20.6643 12.1583 19.8466 11.6813L15.717 9.27244C15.4112 9.09402 15.0634 9 14.7093 9H12.25Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const GestureUpIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'gesture-up',
    ref,
    icon: element,
  },
));

GestureUpIcon.displayName = 'GestureUpIcon';

export default GestureUpIcon;
